import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import moment from 'moment';
import { dataItem } from '../data/data';
import { Controller } from '../common/Controller';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { UiHelper } from '../common/helpers/UiHelper';
import { Helper } from '../common/helpers/Helper';
import { ProfileFields } from '../components/ProfileFields';
import { Consent } from '../components/Consent';
import { Customize } from '../components/Customize';
import { StepperComponent } from '../components/quizzing/StepperComponent';
import { CommonStyles } from '../styles/Styles';
import { AppConfig } from '../AppConfig';
import { AppHelper } from '../helpers/AppHelper';

export class Profile extends Component {
  constructor(props) {
    super(props);
    this.appUser = Controller.get().userMgr().getAppUser()
    this.activeStepByKey = {
      basicInfo: 0,
      contactInfo: 1,
      preferedQSections: 3,
    }
    this.state = {
      fetchState: ApiHelper.State.LOADING,
      inProcess: false,
      activeStep: this.getActiveStepIndex(),
      preReqFail: false,
      consentCheck: true,
      adult: false,
      errMsg: null,
      showConsentCompleteMsg: false
    };
    this.data = dataItem,
    this.responseByQuestionId = {}

  }

  componentDidMount() {
    this.setUser()
    this.preReqCheck()
  }

  fetchSections = (callback) => {
    ApiHelper.call(
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['/miscs/quiz-sections'], { quizId: AppConfig.quizId }) },
      function (err, result) {
        if (err) {
          return callback(err)
        }
        const sectionIds = []
        if (result && result.sections) {
          for (const item of result.sections) {
            sectionIds.push(item.id)
          }
        }

        return callback(null, { sectionIds })
      }.bind(this))
  }

  getActiveStepIndex = () => {
    if (this.props.location.state &&
      this.props.location.state.indexKey !== undefined &&
      this.activeStepByKey[this.props.location.state.indexKey] !== undefined) {
      return this.activeStepByKey[this.props.location.state.indexKey]
    } else {
      return AppHelper.getProfileActiveIndex()
    }
  }

  setUser = () => {
    for (const item of dataItem.yourInfoFields) {
      if (this.appUser[item.id]) {
        this.responseByQuestionId[item.id] = this.appUser[item.id]
      }
    }

    if (this.responseByQuestionId.referralCode) {
      delete this.responseByQuestionId.referralCode
    }

    if (this.responseByQuestionId.dob) {
      this.responseByQuestionId.dob = moment(this.responseByQuestionId.dob, 'DD-MMM-YYYY').valueOf()
    }

    for (const item of dataItem.contactInfoFields) {
      if (this.appUser[item.id]) {
        this.responseByQuestionId[item.id] = this.appUser[item.id]
      }
    }
    if (this.appUser.preferedQSections &&
      this.appUser.preferedQSections.length > 0) {
      this.responseByQuestionId.preferedQSections = this.appUser.preferedQSections
    }
    if (this.appUser.consentGuardianName) {
      this.responseByQuestionId.consentGuardianName = this.appUser.consentGuardianName
    }
    if (this.appUser.consentGuardianEmail) {
      this.responseByQuestionId.consentGuardianEmail = this.appUser.consentGuardianEmail
    }
    //console.log('setUser', this.responseByQuestionId)
  }

  handleState = (id, value) => {
    this.responseByQuestionId[id] = value
    //console.log('responseByQuestionId', this.responseByQuestionId)
  }

  getJsonBody = () => {
    if (this.state.activeStep === 0) {
      return ({
        updateAction: 'basicInfo',
        referralCode: this.responseByQuestionId.referralCode,
        dob: moment(this.responseByQuestionId.dob).format('DD-MMM-YYYY'),
        addressCountryCode: this.responseByQuestionId.addressCountryCode
      })
    } else if (this.state.activeStep === 1) {
      return ({
        updateAction: 'contactInfo',
        givenname: this.responseByQuestionId.givenname,
        familyname: this.responseByQuestionId.familyname,
        phone: this.responseByQuestionId.phone,
        addressL1: this.responseByQuestionId.addressL1,
        addressL2: this.responseByQuestionId.addressL2,
        addressCity: this.responseByQuestionId.addressCity,
        addressState: this.responseByQuestionId.addressState,
        addressZip: this.responseByQuestionId.addressZip,
      })
    } else if (this.state.activeStep === 2 && this.state.adult) {
      return {
        updateAction: 'consentForAdults',
      }
    } else if (this.state.activeStep === 2 && !this.state.adult) {
      return {
        updateAction: 'consentByNonAdults',
        consentGuardianName: this.responseByQuestionId.consentGuardianName,
        consentGuardianEmail: this.responseByQuestionId.consentGuardianEmail,
      }
    }
    // else if (this.state.activeStep === 3) {
    //   return {
    //     updateAction: 'preferedQSections',
    //     preferedQSections: this.responseByQuestionId.preferedQSections
    //   }
    // }
    return null
  }

  updateProfile = () => {
    //console.log('updateProfile', this.responseByQuestionId)
    let jsonBody = this.getJsonBody()
    if (!jsonBody) return
    jsonBody = Helper.removeNullValues(jsonBody)
    //console.log('jsonBody', jsonBody)
    this.setState({
      inProcess: true,
      errMsg: null
    })

    ApiHelper.call(
      {
        method: 'PUT',
        endPoint: ApiHelper.makeUrlPath(['users', 'me']),
        jsonBody: jsonBody
      },
      function (err, result) {
        if (err) {
          this.setState({
            errMsg: Helper.getErrorMsg(err),
            inProcess: false
          })
          return
        }
        if (this.state.activeStep === 2 && this.state.adult) {
          this.updatePreferedQSections((err, data) => {
            if (err) {
              // this.setState({
              //   errMsg: Helper.getErrorMsg(err),
              //   inProcess: false
              // })
              console.log('updatePreferedQSections failed', err)
            }
            this.updateAppUser()
            return
          })
        } else {
          this.updateAppUser()
        }
        //this.responseByQuestionId = {}
      }.bind(this))
  }

  updatePreferedQSections = (callback) => {
    this.fetchSections((err, data) => {
      if(err) {
        return callback(err)
      }
      const jsonBody = {
        updateAction: 'preferedQSections',
        preferedQSections: data.sectionIds || []
      }
      ApiHelper.call(
        {
          method: 'PUT',
          endPoint: ApiHelper.makeUrlPath(['users', 'me']),
          jsonBody: jsonBody
        },
        function (err, result) {
          if (err) {
            return callback(err)
          }
          return callback(null)
        }.bind(this))
    })
  }

  updateAppUser = () => { //TODO
    Controller.get().loginMgr()._fetchAppUser((err, data) => {
      // if (this.state.activeStep === 3) {
      //   this.setState({
      //     inProcess: false,
      //     errMsg: null
      //   })
      //   Controller.get().pushRoute(AppConfig.clientDashboard);
      // } else
      if (this.state.activeStep === 2 && !this.state.adult) {
        this.setState({
          inProcess: false,
          errMsg: null
        })
      } else if (this.state.activeStep === 2 && this.state.adult) {
        this.setState({
          // activeStep: this.state.activeStep + 1,
          inProcess: false,
          errMsg: null,
          showConsentCompleteMsg: true
        })
        Controller.get().pushRoute(AppConfig.clientDashboard);
      // } else if (this.state.activeStep < 3) {
      } else if (this.state.activeStep < 2) {
        this.setState({
          activeStep: this.state.activeStep + 1,
          inProcess: false,
          errMsg: null
        })
      }
    })
  }

  handleStep = (step, currentStepId) => () => {
    //console.log('handleStep', currentStepId)
    if (!AppHelper.shouldMoveNextProfileStep(currentStepId)) {
      return
    } else {
      this.setState({
        activeStep: step,
        errMsg: null
      });
    }
  };

  preReqCheck = () => {
    if (!this.responseByQuestionId.dob) {
      this.setState({
        fetchState: ApiHelper.State.READY
      });
      return
    }
    const age = Helper.calculateAge(this.responseByQuestionId.dob)
    //console.log('age', age)
    if (this.responseByQuestionId.addressCountryCode === 'OTHER' || age < AppConfig.AGE_LOWER_LIMIT) {
      this.setState({
        preReqFail: true,
        fetchState: ApiHelper.State.READY
      });
      return
    } else if (age >= AppConfig.AGE_UPPER_LIMIT) {
      this.setState({
        consentCheck: false,
        adult: true,
        fetchState: ApiHelper.State.READY
      });
    } else {
      this.setState({
        consentCheck: true,
        adult: false,
        fetchState: ApiHelper.State.READY
      });
    }
  }

  yourInfoStepper = () => {
    const age = Helper.calculateAge(this.responseByQuestionId.dob)
    //console.log('age', age)
    if (this.responseByQuestionId.addressCountryCode === 'OTHER' || age < AppConfig.AGE_LOWER_LIMIT) {
      this.setState({
        preReqFail: true
      });
      return
    } else if (age >= AppConfig.AGE_UPPER_LIMIT) {
      this.setState({
        consentCheck: false,
        adult: true
      });
      this.updateProfile()
    } else {
      this.setState({
        consentCheck: true,
        adult: false,
      });
      this.updateProfile()
    }
  }

  nextStepper = () => {
    //console.log('this.responseByQuestionId', this.responseByQuestionId)
    if (this.state.activeStep === 0) {
      this.yourInfoStepper()
    } else {
      this.updateProfile()
    }
  }

  continueButton = () => {
    this.setState({
      consentCheck: false,
    });
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }

  getPreReqFail = () => {
    const age = Helper.calculateAge(this.responseByQuestionId.dob)
    if (this.state.preReqFail && this.responseByQuestionId.addressCountryCode === 'OTHER') {
      return (
        <div className={css(CommonStyles.innerContainer, CommonStyles.innerErrorContainer)}>
          <p className={css(CommonStyles.stepperTitleContent)}>Outside of United States Coming Soon</p>
          <p className={css(CommonStyles.stepperSubTitleContent)}>
            {'Right now, we are not able to collect data from people in your area.'}
          </p>
          {/*\n\n If you input your country, we will contact you when it is available.'*/}
        </div>
      )
    } else if (this.state.preReqFail && age < AppConfig.AGE_LOWER_LIMIT) {
      return (
        <div className={css(CommonStyles.innerContainer, CommonStyles.innerErrorContainer)}>
          <p className={css(CommonStyles.stepperTitleContent)}>We’re Sorry!</p>
          <p className={css(CommonStyles.stepperSubTitleContent)}>
            {'Right now, you must be over ' + AppConfig.AGE_LOWER_LIMIT + ' years old \n to participate in this research study.'}
            {/*\n\n If you input your birthday we will contact you when you’re eligible to participate.'*/}
          </p>
        </div>
      )
    }
  }

  getCompletionStatus = () => {
    for (const item of this.data.profileStepper) {
      item.complete = AppHelper.isProfileSectionComplete(item.key)
    }
  }

  doUpdatePreferedQSections = () => {
    this.setState({
      inProcess: true,
      errMsg: null
    })
    this.updatePreferedQSections((err, data) => {
      if (err) {
        this.setState({
          errMsg: Helper.getErrorMsg(err),
          inProcess: false
        })
        return
      }
      this.updateAppUser()
    })
  }

  readyView() {
    this.getCompletionStatus()
    return (
      <div className={css(Styles.outerContainer)}>
        {!this.state.preReqFail &&
          <StepperComponent
            data={this.data.profileStepper}
            handleStep={this.handleStep}
            activeStep={this.state.activeStep}
          />
        }
        {!this.state.preReqFail &&
          <div className={css(Styles.stepperOuterContent)}>
            {this.state.activeStep === 0 &&
              <ProfileFields
                title={'Basic Info'}
                currentStep={'BASIC_INFO'}
                formFields={dataItem.yourInfoFields}
                handleState={this.handleState}
                nextStepper={this.nextStepper}
                inProcess={this.state.inProcess}
                responseByQuestionId={this.responseByQuestionId}
              />
            }

            {this.state.activeStep === 1 &&
              <ProfileFields
                title={'Contact Info'}
                currentStep={'CONTACT_INFO'}
                formFields={dataItem.contactInfoFields}
                handleState={this.handleState}
                nextStepper={this.nextStepper}
                inProcess={this.state.inProcess}
                responseByQuestionId={this.responseByQuestionId}
              />
            }

            {this.state.activeStep === 2 &&
              <Consent
                formField={dataItem.consentField}
                formFieldsParentConsent={dataItem.parentConsentField}
                currentStep={'CONSENT_INFO'}
                handleState={this.handleState}
                nextStepper={this.nextStepper}
                consentCheck={this.state.consentCheck}
                adult={this.state.adult}
                responseByQuestionId={this.responseByQuestionId}
                inProcess={this.state.inProcess}
                continueButton={this.continueButton}
                doUpdatePreferedQSections={this.doUpdatePreferedQSections}
              />
            }

            {/* {this.state.activeStep === 3 &&
              <Customize
                onTileClicked={this.onTileClicked}
                nextStepper={this.nextStepper}
                showConsentCompleteMsg={this.state.showConsentCompleteMsg}
                //selectedTileIds={this.state.selectedTileIds}
                handleState={this.handleState}
                adult={this.state.adult}
                inProcess={this.state.inProcess}
                responseByQuestionId={this.responseByQuestionId}
              />
            } */}
          </div>
        }
        <div className={css(CommonStyles.errMsgContainer)}>
          <p className={css(CommonStyles.errMsg)}>{this.state.errMsg}</p>
        </div>
        {this.getPreReqFail()}
      </div>
    );
  }
}


const Styles = StyleSheet.create({
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'flex-start',
    maxWidth: 1200,
    '@media (max-width: 768px)': {
      maxWidth: '100%',
    },
    '@media(min-width: 768px) and (max-width: 1023px)': {
    },
  },
  stepperOuterContent: {
    // flex: 1,
    display: 'flex',
    justifyContent: 'center',
    marginTop: 50,
    '@media (max-width: 768px)': {
      margin: 15
    },
  },
  errMsgPadding: {
    paddingLeft: 10,
    paddingRight: 10
  }
})



// WEBPACK FOOTER //
// ./src/screens/Profile.js